var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoInnerColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1339,
    height: 1037,
    viewBox: "0 0 1339 1037",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C379.794 276.517 842.055 442.28 1339 451.608C1069.64 592.586 771.289 682.602 455.711 709.467L0 0Z",
    fill: "url(#paint0_linear_165_65165)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M487.82 759.459L666.09 1037L935.77 670.974C789.65 713.988 639.729 743.205 487.82 759.459Z",
    fill: "url(#paint1_linear_165_65165)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.5 386.309L1332.17 132.949L1331.97 132.929C1186.6 217.736 1031.9 287.335 869.851 339.649C960.56 360.822 1052.59 376.448 1145.5 386.309Z",
    fill: "url(#paint2_linear_165_65165)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_65165",
    x1: 2.65989e-7,
    y1: 518.5,
    x2: 1338.99,
    y2: 521.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_165_65165",
    x1: 2.65989e-7,
    y1: 518.5,
    x2: 1338.99,
    y2: 521.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_165_65165",
    x1: 2.65989e-7,
    y1: 518.5,
    x2: 1338.99,
    y2: 521.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInnerColored);
export default __webpack_public_path__ + "static/media/logo-inner-colored.7ec63cdfc4d3c81e776a0a34acfe19c4.svg";
export { ForwardRef as ReactComponent };